import React from "react";
import styled from "styled-components";
import { mediaQueries } from "../shared/config";
import { useMediaQuery } from "react-responsive";

const OuterContainer = styled.div`
    background-color: #868066;
    width: 100%;
    height: fit-content;
    padding-bottom: 7%;
`;

const Container1 = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 2%;

  ${mediaQueries.mobile} {
  margin-bottom: 6%;
  }
`;

const Container = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 7%;

  ${mediaQueries.mobile} {
  margin-bottom: 6%;
  }
`;

const ContainerM = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 7%;

  ${mediaQueries.mobile} {
  margin-bottom: 2%;
  }
`;

const Title = styled.div`
  color: #3f2b1b;
  font-family: "Inter", sans-serif;
  font-size: 8vh;
  font-style: normal;
  font-weight: 800; /* bold */
  text-transform: uppercase;
  padding-bottom: 5%;
  padding-top: 8%;
  margin-left: 5%;
  margin-right: 7.3%;
  text-align: center;
  
  ${mediaQueries.mobile} {
    font-size: 5vh;
    text-align: center;
  }
`;

const Text = styled.div`
  width: 80%;
  height: fit-content;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 8%;
  padding: 2%;

  ${mediaQueries.mobile} {
    font-size: 1.25vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 38vw;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 45vh;
  object-fit: cover;

  ${mediaQueries.mobile} {
    height: 40vw;
  }
`;
const ImageContainer = styled.div`
  position: relative;
  width: 140%;
  height: fit-content;
  margin-left: 5%;
  margin-right: 10%;
  &:hover .header {
    opacity: 1;
  }

  ${mediaQueries.mobile} {
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
  }
`;

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 98%;
  height: 10%;
  background-color: rgba(0, 0, 0, 0.7); /* Transparent black background */
  color: white;
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: right;
  font-family: "Oswald", sans-serif;
  font-weight: medium;
  font-size: 2vh;
  text-align: right;
  padding-right: 2%;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`;

const Box1 = styled.div`
    background-color: #9F8B70;
    width: 12%;
    height: 20%;
    position: absolute;
    margin-left: 81%;
    margin-top: 18%;

    ${mediaQueries.mobile} {
        height: 5%;
        width: 15%;
        margin-top: 36%;
        margin-left: 80vw;
    }
`;

// ROW 2 ----------------------------------------------------------------------

const Text2 = styled.div`
  width: 85%;
  height: fit-content;
  margin-left: 7%;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 19.4%;
  padding: 2%;

  ${mediaQueries.mobile} {
  font-size: 1.1vh;
    width: 44vw; /* Adjusted for better mobile display */
    margin : 0 auto; /* Centered on mobile */
    margin-right: 4vw;
    min-height: 40vw;
    margin-top: 0%;
  }
`;

const Text2A = styled.div`
  width: 85%;
  height: fit-content;
  margin-left: 7%;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 23.4%;
  padding: 2%;

  ${mediaQueries.mobile} {
  font-size: 1.4vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin : 0 auto; /* Centered on mobile */
    margin-right: 2vw;
    min-height: 40vw;
    margin-top: 0%;
  }
`;

const ImageContainer2 = styled.div`
  position: relative;
  width: 180vw;
  height: fit-content;
  margin-left: 8vw;
  &:hover .header {
    opacity: 1;
  }

  ${mediaQueries.mobile} {
    width: 48vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
  }
`;

const Image2 = styled.img`
  width: 100%;
  height: 44vh;
  object-fit: cover;

  ${mediaQueries.mobile} {
    height: 40vw;
  }
`;

const Box2 = styled.div`
    background-color: #453D24;
    width: 18%;
    height: 16%;
    position: absolute;
    margin-left: 13%;
    margin-top: 22%;

    ${mediaQueries.mobile} {
        height: 6%;
        width: 23%;
        margin-top: 33%;
        margin-left: 4.5vw;
    }   
`;

// ROW 3 ----------------------------------------------------------------------

const Box3 = styled.div`
background-color: #9F8B70;
width: 16%;
height: 13%;
position: absolute;
margin-left: 32.1%;
margin-top: 17.5%;

${mediaQueries.mobile} {
    height: 2.5%;
    width: 30%;
    margin-top: 34.25%;
    margin-left: 18vw;
}
`

const Text3 = styled.div`
  width: 85%;
  height: fit-content;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 10%;
  padding: 2%;


  ${mediaQueries.mobile} {
    font-size: 1.25vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    min-height: 30vw;
  }
`;

const Image3 = styled.img`
  width: 100%;
  height: 50vh;

    ${mediaQueries.mobile} {
    height: 40vw;
  }
`;

const ImageContainer3 = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  margin-left: 5%;
  margin-right: 6.6%;
  &:hover .header {
    opacity: 1;
}

    ${mediaQueries.mobile} {
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
  }

  }
`;

// ROW 4 ----------------------------------------------------------------------

const ImageContainer4 = styled.div`
  position: relative;
  width: 135vw;
  height: fit-content;
  margin-left: 10vw;
  margin-right: 6.6%;
  &:hover .header {
    opacity: 1;
  }

  ${mediaQueries.mobile} {
    width: 60vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
  }
`;

const Text4 = styled.div`
  width: 45%;
  height: 50vh;
  margin-left: 3.5vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;
  display: flex;

  ${mediaQueries.mobile} {
    font-size: 1.4vh;
    width: 90vw; /* Adjusted for better mobile display */
    margin : 0 auto; /* Centered on mobile */
    height: 5vh;
    padding 0 0 0 0;
    margin-top: -5%;
    align-items: top;
`;

const Image4 = styled.img`
  width: 100%;
  height: 50vh;

  ${mediaQueries.mobile} {
    height: 45vw;
  }
`;

const Box4 = styled.div`
background-color: #7F5D43;
width: 1vw;
height: 50vh;
position: absolute;
margin-left: 62.5vw;
margin-top: 0%;

${mediaQueries.mobile} {
    height: 23%;
    width: 28%;
    margin-top: -23%;
    margin-left: 54vw;
    background-color: #453D24;
}
`

// ROW 5 ----------------------------------------------------------------------

const Box5 = styled.div`
    background-color: #434343;
    width: 14%;
    height: 15%;
    position: absolute;
    margin-left: 51%;
    margin-top: 20%;

    ${mediaQueries.mobile} {
        height: 2%;
        width: 17.5%;
        margin-top: 37.5%;
        margin-left: 42.5vw;
    }
`;


const Text5 = styled.div`
  width: 80%;
  height: fit-content;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 4vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;

  ${mediaQueries.mobile} {
    font-size: 1.6vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
  }
`;


const ImageContainer5 = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  margin-left: 5%;
  margin-right: 12%;
  &:hover .header {
    opacity: 1;
  }

      ${mediaQueries.mobile} {
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
  }
`;

const Image5 = styled.img`
  width: 100%;
  height: 46vh;

      ${mediaQueries.mobile} {
    height: 46vw;
        object-fit: cover;
    
  }
`;

// ROW 6 ----------------------------------------------------------------------

const ImageContainer6 = styled.div`
  position: relative;
  width: 200vw;
  height: 40vh;
  margin-left: 8vw;
  &:hover .header {
    opacity: 1;
  }

  ${mediaQueries.mobile} {
    width: 180vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
        margin-left: 2vw;
            height: 36vw;
  }
`;

const Image7 = styled.img`
  width: 100%;
  height: 50vh;
    object-fit: cover;

  ${mediaQueries.mobile} {
    height: 36vw;
  }
`;  

const ImageContainer7 = styled.div`
  position: relative;
  width: 140vw;
  height: 40vh;
  margin-left: 2vw;
  margin-right: 7%;
  &:hover .header {
    opacity: 1;
  }

    ${mediaQueries.mobile} {
    // width: 40vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    margin-right: 2vw;
        height: 36vw;
  }
`;

const Image6 = styled.img`
  width: 100%;
  height: 50vh;

    ${mediaQueries.mobile} {
    height: 36vw;
  }
`;

//row 7 ----------------------------------------------------------------------



const Text6 = styled.div`
  width: 37vw;
  height: 25vh;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 2.9vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;

  ${mediaQueries.mobile} {
    font-size: 1.35vh;
    width: 43.4vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
  }

`;


const Text7 = styled.div`
  width: 38vw;
  height: 25vh;
  margin-left: 2vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 2.9vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;

    ${mediaQueries.mobile} {
    font-size: 1.35vh;
    width: 42.5vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 0vw;
    height: 40vw;
  }
`;

//row 8 ----------------------------------------------------------------------

const Text8 = styled.div`
  width: 82%;
  height: 25vh;
  margin-left: 2vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 10%;
  padding: 2%;

    ${mediaQueries.mobile} {
    font-size: 1.35vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
    height: 40vw;
  }
`;

const Box8 = styled.div`
    background-color: #9F8B70;
    width: 13%;
    height: 10%;
    position: absolute;
    margin-left: 8vw;
    margin-top: -19vh;

    ${mediaQueries.mobile} {
    width: 24vw; /* Adjusted for better mobile display */
    height: 7%;
    margin-left: 8vw;
    margin-top: -5vh;
  }
`;

const ImageContainer8 = styled.div`
  position: relative;
  width: 90vw;
  height: fit-content;
  margin-left: 16vw;
  &:hover .header {
    opacity: 1;
  }

    ${mediaQueries.mobile} {
    width: 48vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
  }
`;

const Image8 = styled.img`
  width: 100%;
  height: 45vh;

    ${mediaQueries.mobile} {
    height: 40vw;
  }
`;


const Container8 = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 6%;
`;

//row 9 ----------------------------------------------------------------------


const ImageContainer9 = styled.div`
  position: relative;
  width: 100vw;
  height: fit-content;
  margin-left: 12.6vw;
  &:hover .header {
    opacity: 1;
}
    ${mediaQueries.mobile} {
    width: 48vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
  }
`;

const Box9 = styled.div`
background-color: #453D24;
width: 18%;
height: 16%;
position: absolute;
margin-left: 52%;
margin-top: 2%;

    ${mediaQueries.mobile} {
    width: 0vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 6.6vw;
  }
`;
  
const Image9 = styled.img`
  width: 100%;
  height: 50vh;

    ${mediaQueries.mobile} {
    height: 40vw;
  }
`;

const Text9 = styled.div`
  width: 80%;
  height: 25vh;
  margin-left: 5vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 26.5%;
  padding: 2%;

    ${mediaQueries.mobile} {
    font-size: 1.35vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
    height: 40vw;
  }
`;


const Container9 = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 7%;
`;

//  row 10 ----------------------------------------------------------------------

const ImageContainer10 = styled.div`
  position: relative;
  width: 120vw;
  height: fit-content;
  margin-left: 10vw;
  margin-right: 6.6%;
  &:hover .header {
    opacity: 1;
  }

    ${mediaQueries.mobile} {
    width: 44vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
        margin-right: 2vw;
            height: 36vw;
  }
`;

  
const Image10 = styled.img`
  width: 100%;
  height: 45vh;
    object-fit: cover;

    ${mediaQueries.mobile} {
    height: 40vw;
  }
`;


const Text10 = styled.div`
  width: 62%;
  height: 25vh;
  margin-left: 11.8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 18.75%;
  padding: 2%;
  display: flex;

      ${mediaQueries.mobile} {
    font-size:1.35vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
  }
`;

const Box10 = styled.div`
background-color: #434343;
width: 1vw;
height: 52vh;
position: absolute;
margin-left: 52vw;
margin-top: -1.8%;

    ${mediaQueries.mobile} {
    width: 1vw; /* Adjusted for better mobile display */
    height: 40vw;
    margin: 0 auto; /* Centered on mobile */
    margin-left: 51.5vw;
  }
`

// row 11 ----------------------------------------------------------------------

const Text11 = styled.div`
  width: 80%;
  height: 25vh;
  margin-left: 4vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 6%;
  padding: 2%;


  ${mediaQueries.mobile} {
    font-size:1.35vh;
    width: 42vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
    height: 46vw;
  }
`;

const Box11 = styled.div`
    background-color: #453D24;
    width: 14%;
    height: 15%;
    position: absolute;
    margin-left: 44%;
    margin-top: 20%;

    ${mediaQueries.mobile} {
    background-color: #434343;
    width: 60vw;
    height: 6vw;
    margin: 0 auto; /* Centered on mobile */
    margin-left: 6vw;
    margin-top: 45vw;
`;

const ImageContainer11 = styled.div`
  position: relative;
  width: 110vw;
  height: fit-content;
  margin-left: 11.5vw;
  &:hover .header {
    opacity: 1;
  }

      ${mediaQueries.mobile} {
    width: 52vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
        margin-left: 2vw;
            height: 36vw;
`;



// row 12 ----------------------------------------------------------------------

const Text12 = styled.div`
  width: 66%;
  height: 25vh;
  margin-left: 11.5vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 24.5%;
  padding: 2%;
  display: flex;

    ${mediaQueries.mobile} {
    font-size:1.35vh;
    width: 40vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
    margin-top: 12vw;
  }
`;


const Box12 = styled.div`
background-color: #3F2B1B;
width: 60vw;
height: 2vh;
position: absolute;
margin-left: 0vw;
margin-top: 37%;

    ${mediaQueries.mobile} {
    width: 60vw; /* Adjusted for better mobile display */
    height: 1vw;
    margin: 0 auto; /* Centered on mobile */
    margin-left: 0vw;
    margin-top: 62.25vw;
`

const Box12A = styled.div`
background-color: #3F2B1B;
width: 60vw;
height: 2vh;
position: absolute;
margin-left: 0vw;
margin-top: 37%;

    ${mediaQueries.mobile} {
    width: 56.2vw; /* Adjusted for better mobile display */
    height: 1vw;
    margin: 0 auto; /* Centered on mobile */
    margin-left: 43.8vw;
    margin-top: 96vw;
`


const ImageContainer12 = styled.div`
  position: relative;
  width: 140vw;
  height: fit-content;
  margin-left: 10vw;
  margin-right: 6.6%;
  &:hover .header {
    opacity: 1;
  }

        ${mediaQueries.mobile} {
    width: 52vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
        margin-right: 2vw;
            height: 36vw;
`;

const Image12 = styled.img`
  width: 100%;
  height: 50vh;

  ${mediaQueries.mobile} {
    height: 40vw; /* Adjusted for better mobile display */
`;

// row 13 ----------------------------------------------------------------------


const Text13 = styled.div`
  width: 75%;
  height: fit-content;
  margin-left: 4.5vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 25%;
  padding: 2%;
  display: flex;
`;

const ImageContainer13 = styled.div`
  position: relative;
  width: 90vw;
  height: fit-content;
  margin-left: 8vw;
  &:hover .header {
    opacity: 1;
  }
`;

const Image13 = styled.img`
  width: 100%;
  height: 48vh;
    object-fit: cover;

    ${mediaQueries.mobile} {
    height: 40vh; /* Adjusted for better mobile display */
`;

const Box13 = styled.div`
    background-color: #453D24;
    width: 18%;
    height: 17%;
    position: absolute;
    margin-left: 10%;
    margin-top: 24%;
`;

//row 14 ----------------------------------------------------------------------

const ImageContainer14 = styled.div`
  position: relative;
  width: 140vw;
  height: 40vh;
  margin-left: 8vw;
  &:hover .header {
    opacity: 1;
  }


  ${mediaQueries.mobile} {
    // width: 180vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
        margin-left: 2vw;
            height: 36vw;
  }
`;

const Image14 = styled.img`
  width: 100%;
  height: 50vh;
    object-fit: cover;

    ${mediaQueries.mobile} {
    height: 40vw; /* Adjusted for better mobile display */
}
`;  

const ImageContainer15 = styled.div`
  position: relative;
  width: 200vw;
  height: 40vh;
  margin-left: 2vw;
  margin-right: 7%;
  &:hover .header {
    opacity: 1;
  }


  ${mediaQueries.mobile} {
    width: 180vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
    margin-left: 2vw;
        height: 36vw;
  }
`;

const Image15 = styled.img`
  width: 100%;
  height: 50vh;

  ${mediaQueries.mobile} {
    height: 40vw; /* Adjusted for better mobile display */
}
`;

//row 15 ----------------------------------------------------------------------



const Text14 = styled.div`
  width: 38vw;
  height: 25vh;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 2.75vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;

    ${mediaQueries.mobile} {
    font-size: 1.20vh;
    width: 42.5vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
  }

`;


const Text15 = styled.div`
  width: 37vw;
  height: 25vh;
  margin-left: 2vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 2.75vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 0%;
  padding: 2%;


  ${mediaQueries.mobile} {
    font-size: 1.20vh;
    width: 43.4vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 0vw;
    height: 40vw;
  }

`;

//row 16 ----------------------------------------------------------------------

const ImageContainer16 = styled.div`
  position: relative;
  width: 125vw;
  height: fit-content;
  margin-right: 7%;
  &:hover .header {
    opacity: 1;
  }
         
  ${mediaQueries.mobile} {
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-right: 2vw;
  }
`;

  
const Image16 = styled.img`
  width: 100%;
  height: 58vh;
    object-fit: cover;

      ${mediaQueries.mobile} {
    height: 38vw;
        object-fit: cover;
    
  }
`;


const Text16 = styled.div`
  width: 73%;
  height: 25vh;
  margin-left: 8vw;
  text-align: left;
  font-family: "Oswald", sans-serif;
  font-weight: bold;
  font-size: 3vh;
  color: #3f2b1b;
  background-color: #d1cfc2;
  margin-top: 29vh;
  padding: 2%;
  display: flex;

    ${mediaQueries.mobile} {
    font-size: 1.25vh;
    width: 46vw; /* Adjusted for better mobile display */
    margin: 0 auto; /* Centered on mobile */
    margin-left: 2vw;
    height: 40vw;
  }
`;

const Box16 = styled.div`
background-color: #453D24;
width: 13vw;
height: 12vh;
position: absolute;
margin-left: 78vw;
margin-top: 54vh;

${mediaQueries.mobile} {
  height: 12vw;
  width: 20vw;
  margin-top: 35vw;
  margin-left: 54vw;
  background-color: #453D24;
}
`

const Container13 = styled.div`
  display: flex;
  background-color: #868066;
  width: 100%;
  height: fit-content;
  align-items: flex-start; /* Align items at the start */
  margin-bottom: 10%;
`;


export default function TopSection({ top_articles }) {
    //16 rows.......
  const isMobile = useMediaQuery({ query: '(max-width: 456px)' });
  return (
    <OuterContainer>
      <Title></Title>

      {/* row 1 */}
      <Container1>
        <div>
          <Text>{top_articles[0].article_blurb}</Text>
        </div>
        <ImageContainer>
          <Image src={top_articles[0].article_url} />
          <Header className="header">{top_articles[0].article_byline}</Header>
        </ImageContainer>
        <Box1 />
      </Container1>

      {/* row 2 */}

      <Container>
        <ImageContainer2>
          <Image2 src={top_articles[1].article_url} />
          <Header className="header">{top_articles[1].article_byline}</Header>
        </ImageContainer2>
        <Box2 />
        <div>
          <Text2>{top_articles[1].article_blurb}</Text2>
        </div>
      </Container>

      {/* row 3 */}

      <Container>
        <div>
          <Text3>{top_articles[2].article_blurb}</Text3>
        </div>
        <ImageContainer3>
          <Image3 src={top_articles[2].article_url} />
          <Header className="header">{top_articles[2].article_byline}</Header>
        </ImageContainer3>
        <Box3 />
      </Container>

      {/* row 4 */}

      <>
      {isMobile ? (
        // Mobile implementation
        <>
            <Container>
              <ImageContainer4>
                <Image4 src={top_articles[3].article_url} />
                <Header className="header">{top_articles[3].article_byline}</Header>
                <Box4 />
              </ImageContainer4>

            </Container>
            <Container>
              <Text4>{top_articles[3].article_blurb}</Text4>

            </Container>
          </>
      ) : (
        <Container>
          <ImageContainer4>
            <Image4 src={top_articles[3].article_url} />
            <Header className="header">{top_articles[3].article_byline}</Header>
          </ImageContainer4>
          <Box4 />
          <div>
            <Text4>{top_articles[3].article_blurb}</Text4>
          </div>
        </Container>
      )}
    </>

        {/* row 5 */}
            <Container>
        <div>
          <Text5>{top_articles[4].article_blurb}</Text5>
        </div>
        <ImageContainer5>
          <Image5 src={top_articles[4].article_url} />
          <Header className="header">{top_articles[4].article_byline}</Header>
        </ImageContainer5>
        <Box5 />
      </Container>

        {/* row 6 */}
              <ContainerM>

        <ImageContainer6>
          <Image6 src={top_articles[5].article_url} />
          <Header className="header">{top_articles[5].article_byline}</Header>
        </ImageContainer6>

        <ImageContainer7>
          <Image7 src={top_articles[6].article_url} />
          <Header className="header">{top_articles[6].article_byline}</Header>
        </ImageContainer7>
      </ContainerM>

      {/* row 7 */}

      <Container>
          <Text6>{top_articles[5].article_blurb}</Text6>
          <Text7>{top_articles[6].article_blurb}</Text7>
      </Container>

      {/* row 8 */}

      <Container8>
        <ImageContainer8>
          <Image8 src={top_articles[7].article_url} />
          <Header className="header">{top_articles[7].article_byline}</Header>
        </ImageContainer8>
        <div>
          <Text8>{top_articles[7].article_blurb}</Text8>
        </div>
      </Container8>

      {/* row 9 */}
      <Container9>
        <ImageContainer9>
          <Image9 src={top_articles[8].article_url} />
          <Header className="header">{top_articles[8].article_byline}</Header>
        </ImageContainer9>
        <Box9 />
        <Box8 />
        <div>
          <Text9>{top_articles[8].article_blurb}</Text9>
        </div>
      </Container9>

      {/* row 10 */}
      <Container>
      <div>
          <Text10>{top_articles[9].article_blurb}</Text10>
        </div>
        <ImageContainer10>
          <Image10 src={top_articles[9].article_url} />
          <Header className="header">{top_articles[9].article_byline}</Header>
        </ImageContainer10>
        <Box10 />
      </Container>

      {/* row 11 */}

      <Container>
        <ImageContainer11>
          <Image8 src={top_articles[10].article_url} />
          <Header className="header">{top_articles[10].article_byline}</Header>
        </ImageContainer11>
        <div>
          <Text11>{top_articles[10].article_blurb}</Text11>
        </div>
        <Box11 />
        <Box12 />
        <Box12A />
      </Container>

      { /* row 12 */}
      <Container>
      <div>
          <Text12>{top_articles[11].article_blurb}</Text12>
        </div>
        <ImageContainer12>
          <Image12 src={top_articles[11].article_url} />
          <Header className="header">{top_articles[11].article_byline}</Header>
        </ImageContainer12>
      </Container>

      { /* row 13 */}
      {isMobile ? (
              <Container>
              <ImageContainer2>
                <Image2 src={top_articles[12].article_url} />
                <Header className="header">{top_articles[12].article_byline}</Header>
              </ImageContainer2>
              <Box2 />
              <div>
                <Text2A >{top_articles[12].article_blurb}</Text2A>
              </div>
            </Container>
      ) :
      // if not mobile
      <Container13>
      <ImageContainer13>
        <Image13 src={top_articles[12].article_url} />
        <Header className="header">{top_articles[12].article_byline}</Header>
      </ImageContainer13>
      <Box13 />
      <div>
        <Text13>{top_articles[12].article_blurb}</Text13>
      </div>
    </Container13>
      }


      { /* row 14 */}

      <Container>
      <ImageContainer14>
        <Image14 src={top_articles[13].article_url} />
        <Header className="header">{top_articles[13].article_byline}</Header>
        </ImageContainer14>
        <ImageContainer15>
        <Image15 src={top_articles[14].article_url} />
        <Header className="header">{top_articles[14].article_byline}</Header>
        </ImageContainer15>

        </Container>

        {/* row 15 */}

        <Container>
        <Text14>{top_articles[13].article_blurb}</Text14>
        <Text15>{top_articles[14].article_blurb}</Text15>
        </Container>

        { /* row 16 */}

        <Container>
      <div>
          <Text16>{top_articles[15].article_blurb}</Text16>
        </div>
        <ImageContainer16>
          <Image16 src={top_articles[15].article_url} />
          <Header className="header">{top_articles[15].article_byline}</Header>
        </ImageContainer16>
        <Box16 />
      </Container>

    </OuterContainer>


  );
}
